import * as React from 'react';

import { ItemsContainer } from "./ItemsContainer";
import log from 'loglevel';


export const ItemsApp = () => {
  log.info(` @ItemsApp`);
  return (      
         <ItemsContainer />  
  );
};

 